import {usePages} from "../api/pageapi";
import {BasePageLayout} from "../components/grouping/BasePageLayout";

export function RulePage(props){
    const {pages} = usePages();
    return <BasePageLayout>
        <div dangerouslySetInnerHTML={{__html: pages ? pages[0]?.htmlFragment?.html : ""}}>

        </div>
    </BasePageLayout>
}